var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const Svg25Nyt = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0.498;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M76.951,111.724a9,9,0,1,0,9,9A9,9,0,0,0,76.951,111.724Zm-.435,11.517v1.181h-4.8v-.984l2.728-2.481a2.088,2.088,0,0,0,.9-1.538,1.141,1.141,0,0,0-1-1.271,1.084,1.084,0,0,0-.18-.007c-.755,0-1.206.506-1.206,1.361v.372H71.721V119.5a2.441,2.441,0,1,1,4.875-.263q0,.09,0,.18a3.055,3.055,0,0,1-1.286,2.366L73.7,123.241ZM82.2,121.87v.072a2.556,2.556,0,0,1-2.492,2.617c-.06,0-.121,0-.181,0h0a2.528,2.528,0,0,1-2.654-2.217l-.04-.314h1.241l.044.226a1.43,1.43,0,0,0,2.822-.309v-.072a1.435,1.435,0,0,0-2.687-.68l-.1.218-1.077-.341.5-3.994h4.045v1.181H78.611l-.165,1.341a2.353,2.353,0,0,1,1.205-.3,2.48,2.48,0,0,1,2.554,2.4C82.206,121.756,82.206,121.813,82.2,121.87Z",
    transform: "translate(-67.951 -111.724)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg25Nyt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/25nyt.d61a4483.svg";
export { ForwardRef as ReactComponent };